<template>
  <div :class="[classDiv, 'placeholder-glow']">
    <div :class="['form-floating', 'mb-3']">
      <money3 v-model="amount" v-bind="config" :name="nome" :class="['form-control','input-money', tam_input, class_placeholder]" 
      :disabled="desabilitado" />
      <tooltips>
        <span v-html="btn_tooltip"></span>
      </tooltips>
      <label :for="(id ? id : '')" v-if="label" class="form-label">
        {{ label }}
      </label>
      <div :id="id_descr" v-if="descricao" class="form-text">

        {{ descricao }}
      </div>
    </div>
  </div>
</template>

<script>
import { Money3Component } from "v-money3";
import Tooltips from "../Tooltips.vue";
export default {
  name: "InputMoney",
  components: {
    money3: Money3Component,
    Tooltips
  },
  data() {
    return {
      amount: "",
    };
  },
  props: {
    tamanho: {
      default: "",
    },
    nome: {
      default: "valor",
    },
    desabilitado: {
      default: false,
    },
    ativa_placeholder: {
      default: false,
    },
    modelValue: '',
    classDiv: {
      default: 'col-4'
    },
    label: {
      default: 'Valor'
    },
    id: String,
    id_descr: String,
    descricao: String,
    tooltip: String,
    tooltip_direcao: {
      default: "top",
    },
  },
  emits: ['update:modelValue'],
  computed: {
    config() {
      return {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      };
    },
    tam_input: function () {
      if (this.tamanho == "") {
        return "";
      } else {
        return "form-control-" + this.tamanho;
      }
    },
    btn_tooltip: function () {
      if (this.tooltip != undefined) {
        return `<button type="button" class="border-0" data-bs-toggle="tooltip" data-bs-placement="` + this.tooltip_direcao + `"
                  data-bs-title="`+ this.tooltip + `">
                  <i class="bi bi-info-circle"></i>
                </button>`
      }
    },
    class_placeholder: function(){
      return (this.ativa_placeholder ? 'placeholder' : '')
    }
  },
  watch: {
    amount(n,o){
      this.$emit('update:modelValue', this.amount)
    },
    modelValue(n,o){
      this.amount = n
    }
  },
};
</script>

<style scoped>
.input-money {
  text-align: right;
}

label {
  font-size: 1rem !important;
  color: #999
}
</style>